var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "align-center my-3", attrs: { "no-gutters": "" } },
        [
          _c("v-icon", { staticClass: "mr-4", attrs: { large: "" } }, [
            _vm._v(" mdi-record-circle ")
          ]),
          _c("div", { staticClass: "title-header" }, [
            _vm._v("Gestión de Cintas")
          ])
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "my-5" },
        [
          _c(
            "v-card-title",
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.searchTapeDeliveries,
                  callback: function($$v) {
                    _vm.searchTapeDeliveries = $$v
                  },
                  expression: "searchTapeDeliveries"
                }
              })
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headersTapeDeliveries.filter(function(i) {
                return i.show
              }),
              search: _vm.searchTapeDeliveries,
              items: _vm.tapeDeliveries,
              options: _vm.tapeDeliveriesOptions,
              "items-per-page": _vm.itemsPerPageTapeDeliveries[3],
              "items-per-page-options": _vm.itemsPerPageTapeDeliveries,
              "footer-props": {
                itemsPerPageOptions: _vm.itemsPerPageTapeDeliveries,
                itemsPerPageText: "Cantidad de cambios de cinta por página",
                prevIcon: "",
                nextIcon: "",
                pageText: ""
              },
              loading: _vm.isFetchingTapeDeliveries,
              "loading-text":
                "Obteniendo los cambios de cinta, espere un momento por favor",
              expanded: [],
              "show-expand": "",
              "single-expand": ""
            },
            on: {
              "update:options": function($event) {
                _vm.tapeDeliveriesOptions = $event
              },
              "item-expanded": _vm.showTapeChangeDetails
            },
            scopedSlots: _vm._u([
              {
                key: "no-data",
                fn: function() {
                  return [_vm._v(" No hay cambios de cintas registrados ")]
                },
                proxy: true
              },
              {
                key: "expanded-item",
                fn: function(ref) {
                  var headers = ref.headers
                  var item = ref.item
                  return [
                    _c("td"),
                    _c(
                      "td",
                      { attrs: { colspan: headers.length - 1 } },
                      [
                        _c(
                          "v-skeleton-loader",
                          {
                            staticClass: "my-2",
                            attrs: {
                              color: "#eceff1",
                              loading: _vm.isFetchingTapeDelivery,
                              type: "list-item@3"
                            }
                          },
                          [
                            _c(
                              "v-list",
                              {
                                attrs: {
                                  color: "transparent",
                                  "three-line": ""
                                }
                              },
                              [
                                _c("v-subheader", [
                                  _c(
                                    "h4",
                                    { staticClass: "overline green--text" },
                                    [
                                      _vm._v(
                                        " Detalles del Ticket #" +
                                          _vm._s(item.ticketId) +
                                          " "
                                      )
                                    ]
                                  )
                                ]),
                                _c("v-divider"),
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-subtitle", [
                                          _c("strong", [
                                            _vm._v("Entregadas por Daycohost:")
                                          ]),
                                          _vm._v(
                                            " " + _vm._s(_vm.givenTapes) + " "
                                          )
                                        ]),
                                        _c("v-list-item-subtitle", [
                                          _c("strong", [
                                            _vm._v("Recibidas por Daycohost:")
                                          ]),
                                          _vm._v(
                                            " " + _vm._s(_vm.takenTapes) + " "
                                          )
                                        ]),
                                        _c("v-list-item-subtitle", [
                                          _c(
                                            "a",
                                            {
                                              on: {
                                                click: _vm.showTapeDeliverySheet
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "Visualizar Planilla de Gestión de Cintas"
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "div",
            { staticClass: "grey lighten-4 ma-0 py-2" },
            [
              _c("v-pagination", {
                attrs: {
                  "total-visible": 7,
                  length: _vm.tapeDeliveriesListOptions.pages
                },
                on: {
                  input: function($event) {
                    return _vm.changeTapeDeliveries()
                  }
                },
                model: {
                  value: _vm.pageTapeDeliveries,
                  callback: function($$v) {
                    _vm.pageTapeDeliveries = $$v
                  },
                  expression: "pageTapeDeliveries"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }